import { WorkingShiftDateRangeHourRange } from '../calendar/working-shift-date-range-hour-range';
import { isArray } from 'util';

export class WorkingShiftDateRangeHourRangeBuilder {
  static fromJson(json) {
    return (json)
      ? new WorkingShiftDateRangeHourRange(
        json.hash,
        json.startTime,
        json.endTime
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(WorkingShiftDateRangeHourRangeBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/working-shift-date-range-hour-range.builder.ts